import { useCallback, useEffect, useState } from 'react';

interface UseCountdownResult {
  secondsLeft: number;
  startCountdown: (seconds: number) => void;
}

export const useCountdown = (): UseCountdownResult => {
  const [countdownRevision, setCountdownRevision] = useState<number>(0);
  const [secondsLeft, setSecondsLeft] = useState<number>(0);

  useEffect(() => {
    if (!secondsLeft) return;

    const timeoutId = window.setTimeout(() => {
      setSecondsLeft((currentValue) => Math.max(currentValue - 1, 0));
    }, 1000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [countdownRevision, secondsLeft]);

  const startCountdown = useCallback((seconds: number): void => {
    setSecondsLeft(Number.isInteger(seconds) && seconds > 0 ? seconds : 0);
    setCountdownRevision((currentValue) => currentValue + 1);
  }, []);

  return {
    secondsLeft,
    startCountdown
  };
};